export default [{
	titulo: 'Legislações Municipais',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/legislacoes-municipais',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]